import { gql } from '@apollo/client';

export const QUERY_ALL_ARTICLES = gql`
  query articles($status: ArticleStatus = PUBLISHED, $type: ArticleType) {
    articles(status: $status, type: $type) {
      booking {
        id
        title
      }
      payment {
        id
        title
      }
      property {
        id
        title
      }
    }
  }
`;

export const QUERY_RELEASE_NOTES = gql`
  query queryReleaseNotes($pageNumber: Int = 1, $pageSize: Int = 99) {
    listReleaseNotes(pageNumber: $pageNumber, pageSize: $pageSize) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        numPages
      }
      totalCount
      results {
        id
        title
        content
        status
        publishedAt
        article {
          id
          title
        }
      }
    }
  }
`;

export const MUTATION_CREATE_RELEASE_NOTE = gql`
  mutation createReleaseNote($input: CreateReleaseNoteInput!) {
    createReleaseNote(input: $input) {
      releaseNote {
        id
      }
    }
  }
`;

export const MUTATION_DELETE_RELEASE_NOTE = gql`
  mutation deleteReleaseNote($input: DeleteReleaseNoteInput!) {
    deleteReleaseNote(input: $input) {
      success
    }
  }
`;

export const MUTATION_CHANGE_PUBLISHED_AT = gql`
  mutation changePublishedAt($input: ScheduleReleaseNoteInput!) {
    scheduleReleaseNote(input: $input) {
      success
    }
  }
`;
